export const statusColors = {
  reserved: "#E6D2EE",
  submitted: "#E0E0E0",
  pending_approval: "#FFECB3",
  change_order: "#F8D7DA",
  scheduled: "#FFE5CC",
  picked: "#CCE7FF",
  completed: "#D5F5D5",
  canceled: "#F8D7DA",
};

export const hoverColors = {
  reserved: "#8A559B",
  submitted: "#CCCCCC",
  pending_approval: "#FFE08A",
  change_order: "#F0BEC1",
  scheduled: "#FFD4B3",
  picked: "#B3D9FF",
  completed: "#C1E8C1",
  canceled: "#F0BEC1",
};

export const shipmentColor = "#B2DFDB";
export const shipmentHoverColor = "#80CBC4";
